import { use, useEffect, useRef, useState } from "react";
import { InputDefault } from "../../../components/forms/InputDefault";
import { SelectUserRole } from "../../../components/forms/selects/SelectUserRole";
import { FiCamera, FiEye, FiEyeOff, FiLock, FiX } from "react-icons/fi";
import { UserService } from "../../../services/UserService";
import { BtnDefault } from "../../../components/buttons/BtnDefault";
import { SelectUserStatus } from "../../../components/forms/selects/SelectUserStatus";

export const UserUpdate = ({ dataSelected, open, setOpen, refreshData }) => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [preview, setPreview] = useState(null);
  const fileInputRef = useRef(null);

  const [data, setData] = useState({
    image: "",
    name: "",
    email: "",
    phone_number: "",
    role_id: null,
    status_id: null,
    password: "",
  });

  useEffect(() => {
    if (dataSelected) {
      setData({
        image: dataSelected?.image,
        name: dataSelected.name,
        email: dataSelected.email,
        phone_number: dataSelected?.phone_number,
        role_id: dataSelected?.role?.id,
        status_id: dataSelected?.status?.id,
        password: dataSelected.password,
      });
    }
  }, [dataSelected]);

  const [error, setError] = useState({
    image: null,
    name: "",
    email: "",
    phone_number: "",
    role_id: "",
    status_id: "",
    password: "",
  });

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2048 * 1024) {
        setError(prev => ({ ...prev, image: "Ukuran file maksimal 2MB" }));
        return;
      }
      setData({ ...data, image: file });
      setPreview(URL.createObjectURL(file)); // Buat URL sementara untuk preview
      setError(prev => ({ ...prev, image: null }));
    }
  };

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Reset error state
    setError({});

    // 1. Validasi Sederhana di Frontend
    if (!data.name) {
      setError(prev => ({ ...prev, name: "Nama tidak boleh kosong" }));
      setLoading(false);
      return;
    }

    if (!data.role_id) {
      setError(prev => ({ ...prev, role_id: "Role harus dipilih" }));
      setLoading(false);
      return;
    }

    try {
      // 2. Gunakan FormData untuk mengirim File
      const formData = new FormData();
      if (data.image) {
        formData.append("image", data.image);
      }
      formData.append("name", data.name);
      formData.append("email", data.email);
      formData.append("phone_number", data.phone_number);
      formData.append("role_id", data.role_id);
      formData.append("status_id", data.status_id);
      formData.append("password", data.password);

      const response = await UserService.update({ data: formData, id: dataSelected?.id });

      setOpen(false);
      resetForm();
      refreshData();

    } catch (err) {
      console.log(err);

    } finally {
      setLoading(false);
    }
  };

  // Fungsi helper untuk reset form agar kode bersih
  const resetForm = () => {
    setData({
      image: null,
      name: "",
      email: "",
      phone_number: "",
      role_id: null,
      password: "",
    });
    setPreview(null);
    setError({});
  };

  return (
    <>
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center bg-black p-5 ${open
          ? "bg-black/30 pointer-events-auto"
          : "bg-transparent pointer-events-none"
          }`}
      >
        <div
          className={` w-full max-w-[500px] bg-white shadow-xl rounded-xl flex flex-col gap-3 overflow-hidden transition-all duration-500 ${open ? "scale-100" : "scale-0"
            }`}
        >
          {/* Modal Header */}
          <div className="w-full flex items-center justify-center p-3 bg-gray-500 text-white">
            <p className="text-xl font-semibold">Update Data Pengguna</p>
          </div>

          {/* Main Content */}
          <form
            onSubmit={handleSubmit}
            className="w-full p-3 flex flex-col gap-3"
          >

            <div className="flex flex-col items-center gap-2">
              <div
                onClick={() => fileInputRef.current.click()}
                className="relative w-24 h-24 rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center cursor-pointer hover:bg-gray-50 overflow-hidden"
              >
                {preview ? (
                  <img src={preview} alt="Preview" className="w-full h-full object-cover" />
                ) : (
                  <div className="flex flex-col items-center text-gray-400">
                    <FiCamera size={24} />
                    <span className="text-[10px]">Pilih Foto</span>
                  </div>
                )}
                <input
                  type="file"
                  ref={fileInputRef}
                  className="hidden"
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </div>
              {preview && (
                <button
                  type="button"
                  onClick={() => { setPreview(null); setData({ ...data, image: null }) }}
                  className="text-xs text-red-500 flex items-center gap-1"
                >
                  <FiX /> Hapus Foto
                </button>
              )}
              {error.image && <span className="text-xs text-red-500">{error.image}</span>}
            </div>

            <div className="grid grid-cols-2 gap-3">
            <SelectUserRole
              label={"Role Pengguna"}
              value={data.role_id}
              setValue={(id) => {
                setData((prev) => ({
                  ...prev,
                  role_id: id,
                }));
              }}
            />

            <SelectUserStatus
              label={"Status Pengguna"}
              value={data.status_id}
              setValue={(id) => {
                setData((prev) => ({
                  ...prev,
                  status_id: id,
                }));
              }}
            />
            </div>

            {/* Form Data */}
            <InputDefault
              id="name"
              label="Nama"
              type="text"
              placeholder="Masukkan nama"
              value={data.name}
              onChange={handleChange}
              error={error.name}
            />

            <InputDefault
              id="phoneNumber"
              label="Nomor Telepon"
              type="text"
              placeholder="Masukkan nomor telepon reseller"
              value={data.phone_number}
              onChange={(e) => setData({ ...data, phone_number: e.target.value })}
              error={error.phone_number}
            />

            <InputDefault
              id="email"
              label="Email"
              type="email"
              placeholder="Masukkan email"
              value={data.email}
              onChange={handleChange}
              error={error.email}
            />

            {/* Password Field */}
            <div className="space-y-2">
              <label htmlFor="password" className="block text-sm font-semibold text-gray-700">
                Password
              </label>
              <div className="relative">
                <FiLock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl z-10" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={data.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  className={`w-full pl-12 pr-12 py-3.5 text-sm border-2 rounded-xl transition-all duration-300 outline-none font-normal ${error.password
                    ? 'border-red-400 bg-red-50 focus:border-red-500 focus:ring-4 focus:ring-red-100'
                    : 'border-gray-200 bg-gray-50 focus:border-indigo-500 focus:bg-white focus:ring-4 focus:ring-indigo-100'
                    }`}
                />
                <button
                  type="button"
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-indigo-500 transition-colors p-1"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label="Toggle password visibility"
                >
                  {showPassword ? <FiEyeOff className="text-xl" /> : <FiEye className="text-xl" />}
                </button>
              </div>
              {error.password && (
                <span className="text-xs text-red-600 font-medium mt-1 block">
                  {error.password}
                </span>
              )}
            </div>

            {/* Button Submin n Cancel */}
            <div className="grid grid-cols-2 gap-3 text-white font-semibold">
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="bg-red-500 hover:bg-red-600 px-3 py-2 rounded-md"
              >
                Kembali
              </button>
              <BtnDefault type={"submit"} className="bg-blue-500 hover:bg-blue-600 px-3 py-2 rounded-md">
                {loading ? "Loading..." : "Simpan"}
              </BtnDefault>
            </div>
          </form>

          {/* Footer */}
          <div className="w-full flex items-center justify-center p-3 bg-gray-500 text-white">
            <p className="text-xl font-semibold">Danela Net -||- Andri Studio</p>
          </div>
        </div>
      </div>
    </>
  );
};
